/**
 * Override popover component
 *
 * @version
 * 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { WdOrdersV2Service } from '../../../services/orders/wd-orders-v2.service';
import { IOrderModel } from '../../../interfaces/orders/order-interfaces';

@Component({
  selector: 'app-popover-override',
  templateUrl: './override-popover.component.html',
  styleUrls: ['./override-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OverridePopoverComponent {
  // Override
  @Input() order: IOrderModel;
  @Input() popover: any;
  @Input() type: any;
  @Input() label: any;

  /**
   * Constructor
   * @since 4.71.0
   */
  constructor(
    private wdOrdersService: WdOrdersV2Service,
    @Inject('wdErrorService') public wdErrorService: any,
  ) {}

  /**
   * Close any popover
   *
   * @since 4.71.0
   * @memberof OverridePopoverComponent
   */
  togglePopoverClosed(popover: any) {
    popover.close();
  }

  /**
   * Update order job override
   * @since 4.71.0
   * @memberof OverridePopoverComponent
   */
  async updateOrderJobOverride(
    element: any,
    popover: any,
    type: string,
    label: string,
  ): Promise<void> {
    element.job.override['isUpdating' + label] = true;
    try {
      const overrideValue: string = element.job.override[type + 'Edit'];
      if (overrideValue) {
        // Endpoint requires both name and number
        const updateData: any = {
          jobId: element.job.index,
          jobName: element.job.override.name,
          jobNumber: element.job.override.number,
        };
        // Set updated value
        updateData['job' + label] = overrideValue;
        // Update order job override
        await this.wdOrdersService.updateOrderJobOverride(
          element.index,
          updateData,
        );
      }
    } catch (error) {
      // Error
      this.wdErrorService.userError('Error', error.statusText);
    } finally {
      // Reload Orders @todo Reload ensures filtering is correct. Can we improve efficiency here?
      await this.wdOrdersService.fetchOrders(false);
      element.job.override['isUpdating' + label] = false;
      popover.close();
    }
  }
}
